{
    "ChannelCode": "コード",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "その他の機能を探す",
                "ThanksMessage": "ご参加いただき、ありがとうございました。",
                "WorkingMessage": "翻訳によって、より良い体験を提供できたことを願っています。"
            },
            "FeedbackForm": {
                "FeedbackQuestion": "翻訳の品質はいかがでしたか？",
                "SessionClosedMessage": "ライブ翻訳が終了しました。",
                "ThankYouMessage": "お役に立てたでしょうか！"
            }
        }
    },
    "Continue": "続ける",
    "Control": {
        "Original": "原文",
        "Spacing": "段間隔",
        "TextSize": "文字サイズ",
        "Tts": "TTS"
    },
    "Download": "ダウンロード",
    "Idle": "閒置",
    "Join": "参加する",
    "LanguageSettings": "言語",
    "Live": "進行中",
    "Loading": {
        "Entering": "チャンネルに入室中",
        "Joining": "チャンネルに参加中"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "チャンネルコードを入力してください。",
            "InputPlaceholder": "チャンネルコードを入力",
            "Title": "その場にいて、すべてを理解しましょう。"
        },
        "SelectLanguage": {
            "SearchEmpty": "該当する言語が見つかりません",
            "SearchPlaceholder": "言語を検索",
            "Title": "翻訳言語を選択してください"
        }
    },
    "Pane": {
        "CatchUp": "最新へ移動",
        "Source": "原文",
        "Translation": "翻訳",
        "Tts": "音声読み上げ",
        "TtsShort": "TTS"
    },
    "Share": "共有する",
    "SpeechSpeed": "話す速度",
    "Start": "開始",
    "Submit": "送信",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "このチャンネルは接続数の上限に達しました。"
            }
        },
        "Icon": {
            "ScrollToBottom": "最新へ戻る",
            "ShareLink": "リンクを共有",
            "SpeechRate": "再生速度を設定"
        }
    },
    "Toast": {
        "LanguageChanged": "翻訳言語を{lang}に切り替えました",
        "LinkCopied": "リンクをコピーしました",
        "SourceOff": "原文を非表示にしました",
        "SourceOn": "原文を表示しました",
        "TtsOff": "音声読み上げをオフにしました",
        "TtsOn": "音声読み上げをオンにしました"
    },
    "Transcript": {
        "Start": "文字起こしの先頭"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "原文",
            "summary": "要約",
            "transcript": "書き起こし"
        },
        "translationLanguage": {
            "title": "翻訳言語"
        }
    }
}
